module.exports = "/img/telemovel.png?137c6fa0b45f860c6f35e63487240a7d";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/telemovel.png
// module id = OlwL
// module chunks = 75